import FlexPane from './_flex-pane.js'
import Notification from './_notification.js'
import Button from './_button.js'
import Text from './_text.js'
import Intent from './_intent.js'

export default {
  name: 'BetBonusPromotions',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    disabledContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          opacity: 0.5,
        },
      },
    },
    accaBoostNotification: {
      configSet: Notification,
      configValues: {
        text: {
          container: {
            padding: '0 0 0 8px',
          },
        },
        icon: {
          src: 'acca_boost',
        },
      },
    },
    accaInsuranceNotification: {
      configSet: Notification,
      configValues: {
        text: {
          container: {
            padding: '0 0 0 8px',
          },
        },
        icon: {
          src: 'acca_insurance',
        },
      },
    },
    etbNotification: {
      configSet: Notification,
      configValues: {
        text: {
          container: {
            padding: '0 0 0 8px',
          },
        },
        icon: {
          src: 'info',
        },
      },
    },
    etbReadMoreButton: {
      configSet: Button,
      configValues: {},
    },
    etbReadMoreButtonLabel: {
      configSet: Text,
      configValues: {},
    },
    etbReadMoreIntent: {
      configSet: Intent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
